import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 12,
	viewBox: "0 0 16 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 0C1.232 0 0.605328 0.579469 0.517578 1.32422L8 6L15.4824 1.32422C15.3947 0.579469 14.768 0 14 0H2ZM0.5 2.81396V10.5C0.5 11.3287 1.17125 12 2 12H14C14.8287 12 15.5 11.3287 15.5 10.5V2.81396L8.39697 7.25244C8.15397 7.40394 7.84603 7.40394 7.60303 7.25244L0.5 2.81396Z",
		fill: "#4E7FA0"
	})]
});
const ForwardRef = forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
